<template>
  <div>
    <Input
      @on-focus="openGroup = true"
      :value="name"
      readonly
      placeholder="请选择"
    ></Input>

    <Drawer
      :placement="placement"
      :closable="false"
      v-model="openGroup"
      width="450"
      draggable
      class="my-drawer"
    >
      <car-tool @cars="reCars" :isMore="true"></car-tool>
    </Drawer>
  </div>
</template>
<script>
export default {
  props: ["placement"],
  data() {
    return {
      openGroup: false,
      name: "",
      deviceIdList: [],
    };
  },
  methods: {
    reCars(v) {
      console.log(v);
      
      var t = [];
      this.deviceIdList = [];
      for (let i = 0; i < v.length; i++) {
        t.push(v[i].carNo);
        this.deviceIdList.push(v[i].deviceId);
      }
      if (t.length <= 2) {
        this.name = t.join(",");
      } else {
        this.name = t[0] + "等" + t.length + "台车";
      }
      this.$emit("deviceIdList", this.deviceIdList);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/selecAlotCCar.vue